import script from "./bg-edit-board.vue?vue&type=script&setup=true&lang=ts"
export * from "./bg-edit-board.vue?vue&type=script&setup=true&lang=ts"

import "./bg-edit-board.vue?vue&type=style&index=0&id=67546e55&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67546e55"]])

export default __exports__